import { Component, ElementRef, Injector, OnInit } from '@angular/core';
import { BaseClass } from '../../utility/baseClass';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DynamicDialogConfig, DynamicDialogRef,DialogService } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2';
import { VALIDATION_PATTERNS } from '../../utility/validation-patterns';
import { SubdepartmentService } from '../../main-layout/subdepartment/subdepartment.service';
import { Utilityservice } from '../../utility/utilityservice.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DepartmentmodalComponent } from '../departmentmodal/departmentmodal.component'; 

@Component({
  selector: 'app-subdepartmentmodal',
  templateUrl: './subdepartmentmodal.component.html',
  styleUrls: ['./subdepartmentmodal.component.css']
})
export class SubdepartmentmodalComponent extends BaseClass implements OnInit {
  CSRFToken = '';
  saveTitle = 'Add'
  SubdepartmentForm: FormGroup;
  onlyView: any;
  isEdit: boolean = false;
  activeFlag = [
    {
      'labelname': 'Active',
      'value': 'Y'
    },
    {
      'labelname': 'Inactive',
      'value': 'N'
    }
  ]
  existingdetails: any = {}
  subdeptLabel: String = "";
  departmentList = [];
  hasLimitedAccess = ""; 
  isSupportAdmin = "";
  tssprtlimitedaccess = "N";

  constructor(
    private subdepartmentService: SubdepartmentService,
    public dialogService: DialogService,
    private fb: FormBuilder,
    public router: Router,
    public override  injector: Injector,
    public ref: DynamicDialogRef, private subdepartmentservice: SubdepartmentService,
    public config: DynamicDialogConfig,
    private utilityservice: Utilityservice,
    private spinnerservice: NgxSpinnerService,
    private el: ElementRef,
    public deptRef: DynamicDialogRef
  ) {
    super(injector);
    const dataFromParent = this.config.data;
    this.subdeptLabel = dataFromParent.subdeptlabel;
    this.gettoken();
    if (dataFromParent?.title == 'Modify Subdepartment') {
      this.isEdit = true;
      this.saveTitle = 'Modify'
      this.existingdetails = dataFromParent.datas
    };
     this.utilityservice.configParams$.subscribe((data: any) => {
      const responseArray = data;
      if (responseArray) {
        const config = responseArray; 
        this.hasLimitedAccess = config.haslimitedaccess; 
        this.isSupportAdmin = config.issupportadmin;
        if (this.hasLimitedAccess == "Y" && this.isSupportAdmin == "Y") {
          this.tssprtlimitedaccess = "Y"; 
        }
      } 
    });
  }

  ngOnInit() {
    this.get_dropdown();
    this.formInitiliaze();
    this.getData();
    this.validation_message = {
    'departmentid': [{ type: 'required', message: 'Select Department' }],
    // 'subverticalname': [{ type: 'required', message: 'Enter Sub Vertical' }]
    'subdepartmentname': [{ type: 'required', message: this.subdeptLabel + ' Name is required.' },
    { type: 'maxlength', message: 'Maximum length exceeded' },
    { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning or end' },
    { type: 'ONLYNUMERIC_NOTALLOW', message: 'Only numeric not allowed' },
    { type: 'NOTALLOW_SPECIAL_CHAR', message: "Special character not allowed (% and ')" }
    ]
  }
  }

  get_dropdown() {
    this.subdepartmentService.get_department().subscribe(res => {
      this.departmentList = res;
    })
  }

  get formArr() {
    return this.SubdepartmentForm.get("Rows") as FormArray;
  }
  getData() {
    this.patchValueForms(this.existingdetails[0])
  }
  public validation_message: any;
  
  patchValueForms(data) {
    this.SubdepartmentForm.patchValue({
      'departmentid': data?.departmentid,
      'subdepartmentname': data?.subdepartmentname
    });
  }
  dismiss() {
    Swal.fire({
      title: "Are you sure you want to close?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "No",
      denyButtonText: `Yes`
    }).then((result) => {
      if (result.isDenied) {
        this.ref.close();
      }
    });
  }

  formInitiliaze() {
    this.SubdepartmentForm = this.fb.group({
      subdepartmentname: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(200),
        Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),
        Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC_NOTALLOW),
        Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT),
      ])],
      departmentid: ['', Validators.compose([
        Validators.required,
      ])]
    })
  }

  tempsubddepartment: any;
  addSubdepartment() {
    console.log(this.SubdepartmentForm, "form");
    console.log(this.SubdepartmentForm.invalid);

    if (this.SubdepartmentForm.invalid) {
      this.validateAllFormFields(this.SubdepartmentForm, this.el);
    }

    else if (this.saveTitle == 'Modify') {
      this.modifySubdepartment(this.SubdepartmentForm.value)
    } else {
      Swal.fire({
        title: "Do you want to save the changes?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Save",
        denyButtonText: `Don't Save`
      }).then((value) => {
        if (value.isConfirmed) {
          const payload = { csrftoken: this.CSRFToken, departmentid: this.SubdepartmentForm.value.departmentid, subdepartmentname: this.SubdepartmentForm.value.subdepartmentname };
          this.spinnerservice.show()
          this.subdepartmentservice.postsubdepartment(payload).subscribe((data) => {
            this.tempsubddepartment = data;
            this.spinnerservice.hide();
            if (this.tempsubddepartment.response == 'exists') {
              Swal.fire(this.subdeptLabel + " already exists!", "", "error").then(result => {
              });
            } else {
              this.spinnerservice.hide();
              Swal.fire(this.subdeptLabel + " added successfully!", "", "success").then(result => {
                this.ref.close()
              });
            }
          }, error => {
            this.spinnerservice.hide();
            Swal.fire("Error!", error.error.response, "error");
          });
        } else if (value.isDenied) {
          Swal.fire("Changes are not saved", "", "info")
        }
      });
    }
  }


  modifySubdepartment(data: any) {
    Swal.fire({
      title: "Do you want to save the changes?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Save",
      denyButtonText: `Don't Save`
    })
      .then((value) => {
        if (value.isConfirmed) {
          const payload = { csrftoken: this.CSRFToken, departmentid: this.SubdepartmentForm.value.departmentid, subdepartmentid: this.existingdetails[0].subdepartmentid, subdepartmentname: this.SubdepartmentForm.value.subdepartmentname };
          this.subdepartmentservice.modifysubdepartment(payload).subscribe((data) => {
            this.tempsubddepartment = data;
            this.spinnerservice.hide();
            if (this.tempsubddepartment.response == 'exists') {
              Swal.fire(this.subdeptLabel + " already exists!", "", "error").then(result => {
              });
            } else {
              this.spinnerservice.hide();
              Swal.fire(this.subdeptLabel + " modified successfully!", "", "success").then(result => {
                this.ref.close()
              });
            }
          }, error => {
            this.spinnerservice.hide();
            Swal.fire("Error!", error.error.response, "error");
          });
        } else if (value.isDenied) {
          Swal.fire("Changes are not saved", "", "info")
        }
      });
  }

  gettoken() {
    this.CSRFToken = '';
    this.utilityservice.getCSRFtoken().subscribe(res => {
      this.CSRFToken = res.csrf;
    }, error => {
      Swal.fire(error.error.message, '', 'error');
    });
  }

  addDepartment(title, data) {
    let details = {}
      this.deptRef = this.dialogService.open(DepartmentmodalComponent, {
        header: title,
        width: '50vw',
        height: 'auto',
        data: { title: title, datas: details },
        contentStyle: { overflow: 'hidden' },
      });
      this.deptRef.onClose.subscribe(() => {
        this.get_dropdown();
        this.gettoken();        
      });    
  }
}
